import { tempMeeApi } from '~/services/api';
import { IReferralClaimPayload, IReferralLookupResponse } from './referralTypes';

/**
 * referral-service's claim surface (GOTU-7244). Both verbs share this path and
 * both are public — at click time the caller has no account, so there is no
 * token to send, which is why neither call goes through `getAuthHeaders`.
 */
const REFERRAL_CLAIMS_PATH = '/referral-service/referrals/claims';

/** Fire-and-forget by contract: the response is a bare 204 and carries nothing. */
export const postReferralClaim = async (payload: IReferralClaimPayload): Promise<void> => {
  await tempMeeApi.post(REFERRAL_CLAIMS_PATH, payload);
};

/**
 * Keyed on the code, never on the identifier — the identifier stopped being a
 * read credential when the claim was decoupled from attribution.
 */
export const getReferrerByCode = async (code: string): Promise<IReferralLookupResponse> => {
  const response = await tempMeeApi.get<IReferralLookupResponse>(REFERRAL_CLAIMS_PATH, {
    params: { code },
  });

  return response.data;
};

export const referralApi = {
  getReferrerByCode,
  postReferralClaim,
};
